import { Logo } from "../Logo";

export function Footer(): JSX.Element {
  return (
    <footer className="border-t border-ink-700 py-12 bg-ink-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <Logo size="sm" />
            <p className="mt-3 text-ink-400 text-sm max-w-xs">
              Naucz się języka z prawdziwym lektorem i AI awatarem.
            </p>
          </div>
          <nav className="flex flex-wrap gap-6 text-sm text-ink-300">
            <a href="#how" className="hover:text-white transition">Jak to działa</a>
            <a href="#pricing" className="hover:text-white transition">Cennik</a>
            <a href="mailto:hello@elevationsystems.pl" className="hover:text-white transition">Kontakt</a>
            <a href="#" className="hover:text-white transition">Regulamin</a>
            <a href="#" className="hover:text-white transition">Polityka prywatności</a>
          </nav>
        </div>
        <div className="mt-8 pt-6 border-t border-ink-800 text-xs text-ink-500 flex flex-col md:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Tutor · Elevation Systems</span>
          <span>Made with <span className="text-lime-500">●</span> in Poland</span>
        </div>
      </div>
    </footer>
  );
}
